export const FETCH_USER = 'FETCH_USER'
export const FETCH_REPO = 'FETCH_REPO'
export const FETCH_USER_STARGAZERS = 'FETCH_USER_STARGAZERS'
export const FETCH_REPO_STARGAZERS = 'FETCH_REPO_STARGAZERS'



/** WEBPACK FOOTER **
 ** ./lib/constants.js
 **/